export default {
  lang_name: '\u65E5\u672C\u8A9E',
  tab_main: '\u30E1\u30A4\u30F3', tab_upgrade: '\u5F37\u5316', tab_prestige: '\u8EE2\u751F', tab_achievement: '\u5B9F\u7E3E', tab_mission: '\u30DF\u30C3\u30B7\u30E7\u30F3', tab_domination: '\u5F81\u670D', tab_settings: '\u8A2D\u5B9A',
  hud_cps: '/\u79D2', hud_boost: '\u30D6\u30FC\u30B9\u30C8',
  main_tap_area: '\u30BF\u30C3\u30D7!', main_combo: '\u30B3\u30F3\u30DC',

  prod_informant: '\u60C5\u5831\u54E1', prod_informant_desc: '\u8DEF\u4E0A\u3067\u60C5\u5831\u53CE\u96C6',
  prod_hacker: '\u30CF\u30C3\u30AB\u30FC', prod_hacker_desc: '\u4EBA\u9593\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u4FB5\u5165',
  prod_disguiser: '\u5909\u88C5\u5C02\u9580\u5BB6', prod_disguiser_desc: '\u4EBA\u9593\u306B\u5909\u88C5\u3057\u3066\u6F5C\u5165',
  prod_mindController: '\u5FC3\u7406\u64CD\u4F5C\u58EB', prod_mindController_desc: '\u4EBA\u9593\u306E\u4E16\u8AD6\u64CD\u4F5C',
  prod_secretLab: '\u79D8\u5BC6\u7814\u7A76\u6240', prod_secretLab_desc: '\u30EC\u30D7\u30C6\u30A3\u30EA\u30A2\u30F3\u6280\u8853\u7814\u7A76',
  prod_mediaCell: '\u30E1\u30C7\u30A3\u30A2\u64CD\u4F5C\u73ED', prod_mediaCell_desc: '\u30CB\u30E5\u30FC\u30B9/SNS\u638C\u63E1',
  prod_shadowGovt: '\u5F71\u306E\u653F\u5E9C', prod_shadowGovt_desc: '\u653F\u6CBB\u5BB6\u4EA4\u63DB\u4F5C\u6226',
  prod_deepBase: '\u6DF1\u5C64\u57FA\u5730', prod_deepBase_desc: '\u5730\u4E0B\u5DE8\u5927\u57FA\u5730\u904B\u55B6',
  prod_orbitalStation: '\u8ECC\u9053\u30B9\u30C6\u30FC\u30B7\u30E7\u30F3', prod_orbitalStation_desc: '\u4EBA\u5DE5\u885B\u661F\u76E3\u8996\u7DB2',
  prod_dimensionGate: '\u6B21\u5143\u30B2\u30FC\u30C8', prod_dimensionGate_desc: '\u6BCD\u661F\u304B\u3089\u5175\u529B\u53EC\u559A',
  prod_planetController: '\u60D1\u661F\u5236\u5FA1\u5668', prod_planetController_desc: '\u5730\u7403\u30B7\u30B9\u30C6\u30E0\u76F4\u63A5\u64CD\u4F5C',
  prod_galacticBeacon: '\u9280\u6CB3\u4FE1\u53F7\u6A5F', prod_galacticBeacon_desc: '\u9280\u6CB3\u672C\u90E8\u3068\u76F4\u901A',
  prod_locked: '\u89E3\u653E: ', prod_locked_prestige: '\u8EE2\u751F{n}\u56DE', prod_locked_time: '{n}\u5206\u30D7\u30EC\u30A4',

  milestone_squad: '\u5C0F\u968A\u7DE8\u6210', milestone_company: '\u4E2D\u968A\u7DE8\u6210\u5B8C\u4E86',
  milestone_battalion: '\u5927\u968A\u7D1A\u6226\u529B', milestone_regiment: '\u9023\u968A\u7D1A\u6226\u529B',
  milestone_division: '\u5E2B\u56E3\u7D1A\u6226\u529B', milestone_corps: '\u8ECD\u56E3\u7D1A\u6226\u529B',

  click_basic_training: '\u57FA\u672C\u8A13\u7DF4', click_combat_training: '\u6226\u95D8\u8A13\u7DF4',
  click_psychic_awaken: '\u30B5\u30A4\u30AD\u30C3\u30AF\u899A\u9192', click_transform: '\u5909\u8EAB\u5F37\u5316',
  click_telepathy: '\u30C6\u30EC\u30D1\u30B7\u30FC', click_critical_eye: '\u30AF\u30EA\u30C6\u30A3\u30AB\u30EB\u30A2\u30A4',
  click_dimension_sense: '\u6B21\u5143\u611F\u899A', click_galaxy_field: '\u9280\u6CB3\u529B\u5834',
  click_lethal_strike: '\u5FC5\u6BBA\u306E\u4E00\u6483', click_absolute: '\u7D76\u5BFE\u6F5C\u5165\u529B',
  click_planet_destroyer: '\u60D1\u661F\u7834\u58CA\u8005', click_galaxy_finger: '\u9280\u6CB3\u652F\u914D\u8005\u306E\u6307',

  special_info_network: '\u60C5\u5831\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF', special_info_network_desc: '\u60C5\u5831\u54E1&\u30CF\u30C3\u30AB\u30FC x2',
  special_perfect_disguise: '\u5B8C\u74A7\u306A\u5909\u88C5', special_perfect_disguise_desc: '\u5168\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8 x1.5',
  special_mass_brainwash: '\u5927\u8846\u6D17\u8133', special_mass_brainwash_desc: '\u5FC3\u7406\u64CD\u4F5C&\u30E1\u30C7\u30A3\u30A2 x3',
  special_shadow_network: '\u5F71\u306E\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF', special_shadow_network_desc: '\u30AA\u30D5\u30E9\u30A4\u30F3\u53CE\u5165 +25%',
  special_underground_empire: '\u5730\u4E0B\u5E1D\u56FD', special_underground_empire_desc: '\u5168\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8 x2',
  special_orbital_surveillance: '\u8ECC\u9053\u76E3\u8996\u7DB2', special_orbital_surveillance_desc: '\u30B4\u30FC\u30EB\u30C7\u30F3\u30A4\u30D9\u30F3\u30C8\u983B\u5EA6 +50%',
  special_dimension_supply: '\u6B21\u5143\u5175\u7AD9\u7DDA', special_dimension_supply_desc: '\u30BF\u30C3\u30D7\u53CE\u5165 x5',
  special_galactic_alliance: '\u9280\u6CB3\u540C\u76DF', special_galactic_alliance_desc: '\u6BCE\u79D2 \u{1F6F8} \u53CE\u5165 x10',
  special_combo_master: '\u30B3\u30F3\u30DC\u30DE\u30B9\u30BF\u30FC', special_combo_master_desc: '\u30B3\u30F3\u30DC\u4E0A\u9650 3\u500D',
  special_time_warp: '\u6642\u9593\u6B6A\u66F2', special_time_warp_desc: '\u30AA\u30D5\u30E9\u30A4\u30F3\u30AD\u30E3\u30C3\u30D7 12\u6642\u9593',
  special_agent_synergy: '\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u30B7\u30CA\u30B8\u30FC', special_agent_synergy_desc: '\u6BCE\u79D2 \u{1F6F8} \u53CE\u5165 x1.5',
  special_massive_infiltration: '\u5927\u898F\u6A21\u6F5C\u5165', special_massive_infiltration_desc: '\u6BCE\u79D2 \u{1F6F8} \u53CE\u5165 x2',

  subtab_click: '\u30AF\u30EA\u30C3\u30AF', subtab_special: '\u7279\u6B8A',

  prestige_title: '\u7D44\u7E54\u518D\u7DE8', prestige_total_ip: '\u7DCF\u7D2F\u{1F6F8}', prestige_gc_gain: '\u7372\u5F97\u4E88\u5B9A\u{1F48E}',
  prestige_gc_current: '\u73FE\u5728\u{1F48E}', prestige_execute: '\u7D44\u7E54\u518D\u7DE8',
  prestige_confirm: '\u5168\u3066\u306E\u9032\u884C\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u3066{gc}\u9280\u6CB3\u30AF\u30EC\u30B8\u30C3\u30C8\u3092\u7372\u5F97\u3057\u307E\u3059\u304B\uFF1F',
  prestige_ad_bonus: '\u5E83\u544A\u3092\u898B\u3066\u{1F48E} +50%', prestige_requirement: '\u8EE2\u751F\u306B\u306F100\u5104\u{1F6F8}\u4EE5\u4E0A\u5FC5\u8981',
  prestige2_title: '\u9280\u6CB3\u518D\u7DE8', prestige2_cores_gain: '\u7372\u5F97\u4E88\u5B9A\u{1F52E}', prestige2_cores_current: '\u73FE\u5728\u{1F52E}',
  prestige2_execute: '\u9280\u6CB3\u518D\u7DE8', prestige2_requirement: '\u8EE2\u751F15\u56DE\u4EE5\u4E0A & \u7DCF \u{1F48E} 100\u4EE5\u4E0A\u5FC5\u8981',
  prestige2_confirm: '\u5168\u3066\u3092\u521D\u671F\u5316\u3057\u3066{cores}\u9280\u6CB3\u30B3\u30A2\u3092\u7372\u5F97\u3057\u307E\u3059\u304B\uFF1F',

  pup_galaxy_mult: '\u9280\u6CB3\u500D\u7387', pup_galaxy_mult_desc: 'レベルごとにCPS x1.5(累積で倍増)',
  pup_infil_accel: '\u6F5C\u5165\u52A0\u901F', pup_infil_accel_desc: '転生後レベルごとに1億 🛸を持ってスタート',
  pup_tap_enhance: '\u30BF\u30C3\u30D7\u5F37\u5316', pup_tap_enhance_desc: 'レベルごとにタップ収入 x2(累積で倍増)',
  pup_offline_expand: '\u30AA\u30D5\u30E9\u30A4\u30F3\u62E1\u5F35', pup_offline_expand_desc: 'オフライン報酬の上限 +1h/Lv(基本8h)',
  pup_offline_eff: '\u30AA\u30D5\u30E9\u30A4\u30F3\u52B9\u7387', pup_offline_eff_desc: 'オフライン収益率 +10%p/Lv(基本50%)',
  pup_agent_discount: '\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u5272\u5F15', pup_agent_discount_desc: 'レベルごとにエージェント雇用コスト -10%(最大 -50%)',
  pup_auto_click: '\u30AA\u30FC\u30C8\u30AF\u30EA\u30C3\u30AF', pup_auto_click_desc: 'レベルごとに毎秒3回自動タップ(最大15回/秒)',
  pup_golden_luck: '\u30B4\u30FC\u30EB\u30C7\u30F3\u904B', pup_golden_luck_desc: 'ゴールデンイベント報酬 +20%/Lv(最大 +200%)',
  pup_combo_keep: '\u30B3\u30F3\u30DC\u7DAD\u6301', pup_combo_keep_desc: 'コンボ持続時間 +0.5秒/Lv(基本2秒)',
  pup_quick_start: '\u30AF\u30A4\u30C3\u30AF\u30B9\u30BF\u30FC\u30C8', pup_quick_start_desc: '転生後に最初の5種エージェントを1体ずつ自動支給',

  p2up_galaxy_speed: '\u9280\u6CB3\u500D\u901F', p2up_galaxy_speed_desc: 'レベルごとに転生時💎獲得量 x2(累積で倍増)',
  p2up_auto_prestige: '\u81EA\u52D5\u8EE2\u751F', p2up_auto_prestige_desc: '100億 🛸 到達時に自動転生',
  p2up_permanent: '\u6C38\u4E45\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8', p2up_permanent_desc: '転生後も初期エージェント3種を保持',
  p2up_dimension_accel: '\u6B21\u5143\u52A0\u901F', p2up_dimension_accel_desc: 'レベルごとにCPS x5(累積、永久)',
  p2up_galaxy_memory: '\u9280\u6CB3\u30E1\u30E2\u30EA\u30FC', p2up_galaxy_memory_desc: '転生時にアクティブブースト3個を保持',
  p2up_spacetime: '\u6642\u7A7A\u6B6A\u66F2', p2up_spacetime_desc: 'オフライン収益率を100%に上昇(永久)',
  p2up_automate: '\u9280\u6CB3\u81EA\u52D5\u5316', p2up_automate_desc: 'エージェントを自動雇用(永久)',

  rank_e: '\u30A4\u30F3\u30BF\u30FC\u30F3', rank_d: '\u4E0B\u7D1A\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8', rank_c: '\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8',
  rank_b: '\u4E0A\u7D1A\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8', rank_a: '\u5E79\u90E8', rank_s: '\u652F\u90E8\u9577',
  rank_ss: '\u7DCF\u5E25', rank_sss: '\u9280\u6CB3\u5927\u541B\u4E3B',

  ach_title: '\u5B9F\u7E3E', ach_filter_all: '\u5168\u3066', ach_filter_tap: '\u30BF\u30C3\u30D7', ach_filter_resource: '\u8CC7\u6E90',
  ach_filter_producer: '\u751F\u7523\u5668', ach_filter_prestige: '\u8EE2\u751F', ach_filter_time: '\u6642\u9593',
  ach_filter_special: '\u7279\u6B8A', ach_filter_ad: '\u6587\u66F8', ach_filter_combo: '\u30B3\u30F3\u30DC',

  ach_t01: '\u6700\u521D\u306E\u4E00\u6B69', ach_t01_reward: '\u30BF\u30C3\u30D7\u30D1\u30EF\u30FC +1',
  ach_t02: '\u6307\u306E\u30A6\u30A9\u30FC\u30DF\u30F3\u30B0\u30A2\u30C3\u30D7', ach_t02_reward: '\u30BF\u30C3\u30D7\u30D1\u30EF\u30FC +5%',
  ach_t03: '\u52E4\u52C9\u306A\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8', ach_t03_reward: '\u30BF\u30C3\u30D7\u30D1\u30EF\u30FC +10%',
  ach_t04: '\u30BF\u30C3\u30C1\u30DE\u30B9\u30BF\u30FC', ach_t04_reward: '\u30BF\u30C3\u30D7\u30D1\u30EF\u30FC +15%',
  ach_t05: '\u722C\u866B\u985E\u306E\u57F7\u5FF5', ach_t05_reward: '\u30BF\u30C3\u30D7\u30D1\u30EF\u30FC +20%',
  ach_t06: '\u9280\u6CB3\u7D1A\u306E\u6307', ach_t06_reward: '\u30BF\u30C3\u30D7\u30D1\u30EF\u30FC +25%',
  ach_t07: '\u30B3\u30F3\u30DC\u898B\u7FD2\u3044', ach_t07_reward: '\u30B3\u30F3\u30DC\u7DAD\u6301 +0.5\u79D2',
  ach_t08: '\u30B3\u30F3\u30DC\u30DE\u30B9\u30BF\u30FC', ach_t08_reward: '\u30B3\u30F3\u30DC\u4E0A\u9650 +0.5',

  ach_r01: '\u5C0F\u3055\u306A\u60C5\u5831', ach_r01_reward: '\u6BCE\u79D2\u{1F6F8} +5%',
  ach_r02: '\u60C5\u5831\u53CE\u96C6\u5BB6', ach_r02_reward: '\u6BCE\u79D2\u{1F6F8} +5%',
  ach_r03: '\u6A5F\u5BC6\u4FDD\u7BA1\u5EAB', ach_r03_reward: '\u6BCE\u79D2\u{1F6F8} +5%',
  ach_r04: '\u767E\u4E07\u6F5C\u5165', ach_r04_reward: '\u6BCE\u79D2\u{1F6F8} +10%',
  ach_r05: '\u5104\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8', ach_r05_reward: '\u6BCE\u79D2\u{1F6F8} +10%',
  ach_r06: '\u5146\u4F5C\u6226', ach_r06_reward: '\u6BCE\u79D2\u{1F6F8} +15%',
  ach_r07: '\u4EAC\u5E1D\u56FD', ach_r07_reward: '\u6BCE\u79D2\u{1F6F8} +15%',
  ach_r08: '\u9280\u6CB3\u306E\u6D77', ach_r08_reward: '\u6BCE\u79D2\u{1F6F8} +20%',
  ach_r09: '\u5B87\u5B99\u306E\u5F7C\u65B9', ach_r09_reward: '\u6BCE\u79D2\u{1F6F8} +20%',
  ach_r10: '\u7121\u9650\u6F5C\u5165', ach_r10_reward: '\u6BCE\u79D2\u{1F6F8} +30%',

  ach_g01: '\u6700\u521D\u306E\u90E8\u4E0B', ach_g01_reward: '\u60C5\u5831\u54E1 x1.5',
  ach_g02: '\u60C5\u5831\u7DB2\u69CB\u7BC9', ach_g02_reward: '\u60C5\u5831\u54E1 x2',
  ach_g03: '\u30CF\u30C3\u30AD\u30F3\u30B0\u958B\u59CB', ach_g03_reward: '\u30CF\u30C3\u30AB\u30FC x2',
  ach_g04: '\u30B5\u30A4\u30D0\u30FC\u8ECD\u56E3', ach_g04_reward: '\u30CF\u30C3\u30AB\u30FC x3',
  ach_g05: '\u5909\u88C5\u306E\u9054\u4EBA', ach_g05_reward: '\u5909\u88C5\u5C02\u9580\u5BB6 x2',
  ach_g06: '\u6D17\u8133\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF', ach_g06_reward: '\u5FC3\u7406\u64CD\u4F5C\u58EB x2',
  ach_g07: '\u30DE\u30C3\u30C9\u30B5\u30A4\u30A8\u30F3\u30B9', ach_g07_reward: '\u79D8\u5BC6\u7814\u7A76\u6240 x2',
  ach_g08: '\u30E1\u30C7\u30A3\u30A2\u638C\u63E1', ach_g08_reward: '\u30E1\u30C7\u30A3\u30A2\u64CD\u4F5C\u73ED x2',
  ach_g09: '\u5F71\u306E\u5185\u95A3', ach_g09_reward: '\u5F71\u306E\u653F\u5E9C x2',
  ach_g10: '\u5730\u4E0B\u5E1D\u56FD', ach_g10_reward: '\u6DF1\u5C64\u57FA\u5730 x2',
  ach_g11: '\u8ECC\u9053\u652F\u914D', ach_g11_reward: '\u8ECC\u9053\u30B9\u30C6\u30FC\u30B7\u30E7\u30F3 x2',
  ach_g12: '\u9280\u6CB3\u306E\u4E3B', ach_g12_reward: '\u5168\u4F53 \u6BCE\u79D2\u{1F6F8} x2',

  ach_p01: '\u521D\u8EE2\u751F', ach_p01_reward: '\u{1F48E} +5\u30DC\u30FC\u30CA\u30B9',
  ach_p02: '\u5FAA\u74B0\u306E\u5473', ach_p02_reward: '\u{1F48E}\u7372\u5F97 +10%',
  ach_p03: '\u30D9\u30C6\u30E9\u30F3', ach_p03_reward: '\u{1F48E}\u7372\u5F97 +10%',
  ach_p04: '\u8EE2\u751F\u4E2D\u6BD2', ach_p04_reward: '\u{1F48E}\u7372\u5F97 +15%',
  ach_p05: '\u7121\u9650\u30EB\u30FC\u30D7', ach_p05_reward: '\u{1F48E}\u7372\u5F97 +20%',
  ach_p06: '\u9280\u6CB3\u306E\u8A18\u61B6', ach_p06_reward: '\u{1F48E}\u7372\u5F97 +25%',
  ach_p07: '\u9280\u6CB3\u518D\u7DE8', ach_p07_reward: '\u{1F52E} +3\u30DC\u30FC\u30CA\u30B9',
  ach_p08: '\u6B21\u5143\u306E\u652F\u914D\u8005', ach_p08_reward: '\u{1F52E}\u7372\u5F97 +20%',

  ach_h01: '\u65B0\u4EBA\u51FA\u52E4', ach_h01_reward: '\u6B53\u8FCE\u30DC\u30FC\u30CA\u30B9 \u{1F6F8} 100',
  ach_h02: '1\u6642\u9593\u52E4\u52D9', ach_h02_reward: '\u6BCE\u79D2\u{1F6F8} +5%',
  ach_h03: '\u534A\u65E5', ach_h03_reward: '\u6BCE\u79D2\u{1F6F8} +10%',
  ach_h04: '24\u6642\u9593\u6F5C\u4F0F', ach_h04_reward: '\u30AA\u30D5\u30E9\u30A4\u30F3 +2\u6642\u9593',
  ach_h05: '3\u65E5\u4F5C\u6226', ach_h05_reward: '\u6BCE\u79D2\u{1F6F8} x1.5',
  ach_h06: '1\u9031\u9593\u6F5C\u5165', ach_h06_reward: '\u6BCE\u79D2\u{1F6F8} x2',

  ach_s01: '\u7591\u3044\u6DF1\u3044\u4EBA\u9593', ach_s01_reward: '\u6A5F\u5BC6\u6587\u66F8 1',
  ach_s02: '\u30AF\u30EA\u30FC\u30F3\u30B9\u30BF\u30FC\u30C8', ach_s02_reward: '\u79F0\u53F7: \u7121\u8B00\u306A\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8',
  ach_s03: '\u30AA\u30FC\u30EB\u30A4\u30F3', ach_s03_reward: '\u6BCE\u79D2\u{1F6F8} +10%',
  ach_s04: '\u30B9\u30D4\u30FC\u30C9\u30E9\u30F3', ach_s04_reward: '\u{1F48E} +10\u30DC\u30FC\u30CA\u30B9',
  ach_s05: '\u30B4\u30FC\u30EB\u30C7\u30F3\u30CF\u30F3\u30BF\u30FC', ach_s05_reward: '\u30A4\u30D9\u30F3\u30C8\u983B\u5EA6 -20%',
  ach_s06: '\u591C\u306E\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8', ach_s06_reward: '\u591C\u9593 \u6BCE\u79D2\u{1F6F8} x1.5',
  ach_s07: '\u7121\u8AB2\u91D1\u6226\u58EB', ach_s07_reward: '\u5E83\u544A\u5831\u916C +30%',
  ach_s08: '\u53CE\u96C6\u5BB6', ach_s08_reward: '\u6BCE\u79D2\u{1F6F8} x3',

  ach_a01: '\u5E83\u544A\u5165\u9580', ach_a01_reward: '\u6A5F\u5BC6\u6587\u66F8 1',
  ach_a02: '\u5E83\u544A\u611B\u597D\u5BB6', ach_a02_reward: '\u6A5F\u5BC6\u6587\u66F8 2',
  ach_a03: '\u5E83\u544A\u30DE\u30B9\u30BF\u30FC', ach_a03_reward: '\u5E83\u544A\u5831\u916C +30%',
  ach_a04: '\u6587\u66F8\u53CE\u96C6\u5BB6', ach_a04_reward: '\u6587\u66F8\u52B9\u679C +20%',
  ach_a05: '\u6A5F\u5BC6\u5C02\u9580\u5BB6', ach_a05_reward: '\u6587\u66F8\u52B9\u679C +50%',

  ach_c01: '\u9023\u6253\u306E\u59CB\u307E\u308A', ach_c01_reward: '\u30B3\u30F3\u30DC\u7DAD\u6301 +0.3\u79D2',
  ach_c02: '\u30EA\u30BA\u30E0\u306B\u4E57\u308B', ach_c02_reward: '\u30B3\u30F3\u30DC\u500D\u7387 +0.1',
  ach_c03: '\u30B4\u30FC\u30EB\u30C7\u30F3\u521D\u5FC3\u8005', ach_c03_reward: '\u30A4\u30D9\u30F3\u30C8\u5831\u916C +10%',
  ach_c04: '\u30B4\u30FC\u30EB\u30C7\u30F3\u53CE\u96C6\u5BB6', ach_c04_reward: '\u30A4\u30D9\u30F3\u30C8\u983B\u5EA6 -10%',
  ach_c05: '\u30C7\u30A4\u30EA\u30FC\u30DE\u30CB\u30A2', ach_c05_reward: '\u30DF\u30C3\u30B7\u30E7\u30F3\u5831\u916C +50%',

  golden_intel_leak: '\u6A5F\u5BC6\u60C5\u5831\u6F0F\u6D29!', golden_agent_frenzy: '\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8\u72C2\u4E71!',
  golden_money_launder: '\u8CC7\u91D1\u6D17\u6D44!', golden_facility_boost: '\u65BD\u8A2D\u7A3C\u50CD\u7387UP!',
  golden_supply_drop: '\u9280\u6CB3\u88DC\u7D66\u54C1!', golden_touch: '\u30BF\u30C3\u30D7!', golden_ad_double: '\u5E83\u544A\u3067 2\u500D',

  offline_title: '\u4E0D\u5728\u4E2D\u4F5C\u6226\u5831\u544A', offline_elapsed: '\u7D4C\u904E\u6642\u9593',
  offline_earned: '\u7372\u5F97\u{1F6F8}', offline_cap: '\u6700\u5927{h}\u6642\u9593\u9069\u7528',
  offline_claim: '\u53D7\u3051\u53D6\u308B', offline_double: '\u5E83\u544A\u30672\u500D ({amount})',
  offline_hours: '{h}\u6642\u9593{m}\u5206',

  settings_title: '\u8A2D\u5B9A', settings_bgm: 'BGM', settings_sfx: '\u52B9\u679C\u97F3', settings_lang: '\u8A00\u8A9E',
  settings_reset: '\u30B2\u30FC\u30E0\u30EA\u30BB\u30C3\u30C8', settings_reset_confirm: '\u5168\u3066\u306E\u9032\u884C\u3092\u524A\u9664\u3057\u3066\u6700\u521D\u304B\u3089\u59CB\u3081\u307E\u3059\u304B\uFF1F',
  settings_stats: '\u7D71\u8A08', settings_total_ip: '\u7DCF\u7372\u5F97\u{1F6F8}', settings_total_taps: '\u7DCF\u30BF\u30C3\u30D7\u6570',
  settings_total_prestiges: '\u7DCF\u8EE2\u751F\u6570', settings_play_time: '\u7DCF\u30D7\u30EC\u30A4\u6642\u9593',
  settings_docs_shop: '\u6A5F\u5BC6\u6587\u66F8\u30B7\u30E7\u30C3\u30D7',

  doc_shop_title: '\u6A5F\u5BC6\u6587\u66F8\u30B7\u30E7\u30C3\u30D7',
  doc_ip_boost: '自動収益加速', doc_ip_boost_desc: '30秒間 毎秒🛸 生産量2倍',
  doc_mega_tap: '強化タップ訓練', doc_mega_tap_desc: '30秒間 タップ収益3倍',
  doc_auto_click: '自動潜入装置', doc_auto_click_desc: '30秒間 毎秒10回自動タップ',
  doc_instant_golden: '緊急ゴールド召喚', doc_instant_golden_desc: 'ゴールドイベント即時発動',
  doc_timeskip: '時間加速器', doc_timeskip_desc: '2時間分の🛸収益を即時獲得',
  doc_prestige_boost: '銀河増幅器', doc_prestige_boost_desc: '次の転生時💎獲得量2倍',
  doc_prestige_boost_active: '次の転生時💎x2 適用待機中', doc_prestige_boost_active_badge: '✅ 適用待機中',

  ad_offline_double: '\u30AA\u30D5\u30E9\u30A4\u30F3\u5831\u916C2\u500D', ad_cps_boost: '\u6BCE\u79D2\u53CE\u5165 x10\u30D6\u30FC\u30B9\u30C8 (15\u79D2)',
  ad_prestige_bonus: '\u8EE2\u751F\u{1F48E} +50%', ad_timeskip: '\u30BF\u30A4\u30E0\u30B9\u30AD\u30C3\u30D7 (2\u6642\u9593)',
  ad_free_docs: '\u7121\u6599\u6A5F\u5BC6\u6587\u66F8', ad_golden_double: '\u30B4\u30FC\u30EB\u30C7\u30F3\u5831\u916C2\u500D',
  ad_start_boost: '\u30B9\u30BF\u30FC\u30C8\u30D6\u30FC\u30B9\u30C8\u30D1\u30C3\u30AF', ad_watching: '\u5E83\u544A\u8AAD\u307F\u8FBC\u307F\u4E2D...',
  ad_cooldown: '{t}\u5F8C\u306B\u5229\u7528\u53EF\u80FD',
  settings_sfx_test: '\u52B9\u679C\u97F3\u30C6\u30B9\u30C8',
  settings_sound_reset: '\u30EA\u30BB\u30C3\u30C8',
  settings_sound_reset_done: '\u30B5\u30A6\u30F3\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3057\u305F',

  num_k: '\u4E07', num_m: '\u5104', num_b: '\u5146', num_t: '\u4EAC', num_qa: '\u5793',
  num_qi: '\u25CB', num_sx: '\u79ED', num_sp: '\u7A63', num_oc: '\u6E9D', num_no: '\u6B63', num_dc: '\u8F09',

  // Daily Missions
  mission_title: '\u30C7\u30A4\u30EA\u30FC\u30DF\u30C3\u30B7\u30E7\u30F3',
  mission_claim: '\u53D7\u53D6',
  mission_all_complete: '\u5168\u5B8C\u4E86\u30DC\u30FC\u30CA\u30B9!',
  mission_clear_label: '\u30DF\u30C3\u30B7\u30E7\u30F3',
  mission_all_clear_label: '\u5168\u9054\u6210',
  ach_unlock_label: '\u5B9F\u7E3E',
  mission_diff_easy: '\u6613',
  mission_diff_normal: '\u4E2D',
  mission_diff_hard: '\u96E3',
  mission_tap_100: '\u8EFD\u3044\u30BF\u30C3\u30C1',
  mission_tap_100_desc: '100\u56DE\u30BF\u30C3\u30D7',
  mission_tap_300: '\u6307\u306E\u30A6\u30A9\u30FC\u30E0\u30A2\u30C3\u30D7',
  mission_tap_300_desc: '300\u56DE\u30BF\u30C3\u30D7',
  mission_buy_5: '\u5C0F\u898F\u6A21\u52DF\u96C6',
  mission_buy_5_desc: '\u751F\u7523\u5668\u30925\u3064\u8CFC\u5165',
  mission_combo_10: '\u30B3\u30F3\u30DC\u30B9\u30BF\u30FC\u30C8',
  mission_combo_10_desc: '10\u30B3\u30F3\u30DC\u9054\u6210',
  mission_golden_1: '\u30E9\u30C3\u30AD\u30FC\u30AD\u30E3\u30C3\u30C1',
  mission_golden_1_desc: '\u30B4\u30FC\u30EB\u30C7\u30F3\u30A4\u30D9\u30F3\u30C8\u30921\u56DE\u30BF\u30C3\u30C1',
  mission_tap_1000: '\u30D8\u30D3\u30FC\u30D2\u30C3\u30BF\u30FC',
  mission_tap_1000_desc: '1,000\u56DE\u30BF\u30C3\u30D7',
  mission_buy_20: '\u90E8\u968A\u7DE8\u6210',
  mission_buy_20_desc: '\u751F\u7523\u5668\u309220\u500B\u8CFC\u5165',
  mission_combo_50: '\u30B3\u30F3\u30DC\u30D7\u30ED',
  mission_combo_50_desc: '50\u30B3\u30F3\u30DC\u9054\u6210',
  mission_golden_3: '\u30B4\u30FC\u30EB\u30C9\u30E9\u30C3\u30B7\u30E5',
  mission_golden_3_desc: '\u30B4\u30FC\u30EB\u30C7\u30F3\u30A4\u30D9\u30F3\u30C8\u30923\u56DE\u30BF\u30C3\u30C1',
  mission_earn_1m: '\u767E\u4E07\u4F5C\u6226',
  mission_earn_1m_desc: '\u{1F6F8} 100\u4E07\u7372\u5F97',
  mission_tap_5000: '\u30BF\u30C3\u30D7\u30DE\u30B7\u30F3',
  mission_tap_5000_desc: '5,000\u56DE\u30BF\u30C3\u30D7',
  mission_buy_50: '\u8ECD\u56E3\u7DE8\u6210',
  mission_buy_50_desc: '\u751F\u7523\u5668\u309250\u500B\u8CFC\u5165',
  mission_combo_100: '\u30B3\u30F3\u30DC\u795E',
  mission_combo_100_desc: '100\u30B3\u30F3\u30DC\u9054\u6210',
  mission_golden_5: '\u30B4\u30FC\u30EB\u30C7\u30F3\u30DE\u30B9\u30BF\u30FC',
  mission_golden_5_desc: '\u30B4\u30FC\u30EB\u30C7\u30F3\u30A4\u30D9\u30F3\u30C8\u30925\u56DE\u30BF\u30C3\u30C1',
  mission_earn_1b: '\u5104\u30A8\u30FC\u30B8\u30A7\u30F3\u30C8',
  mission_earn_1b_desc: '\u{1F6F8} 10\u5104\u7372\u5F97',
  mission_tap_200: '素早い指',
  mission_tap_200_desc: '200回タップ',
  mission_buy_3: '初めての募集',
  mission_buy_3_desc: '生産者3人購入',
  mission_combo_15: 'コンボ入門',
  mission_combo_15_desc: '15コンボ達成',
  mission_earn_10k: 'お小遣い',
  mission_earn_10k_desc: '10K 🛸獲得',
  mission_earn_100k: '資金調達',
  mission_earn_100k_desc: '100K 🛸獲得',
  mission_tap_500: '安定タッパー',
  mission_tap_500_desc: '500回タップ',
  mission_tap_700: '執念',
  mission_tap_700_desc: '700回タップ',
  mission_buy_10: 'チームリーダー',
  mission_buy_10_desc: '生産者10人購入',
  mission_combo_30: 'コンボチェーン',
  mission_combo_30_desc: '30コンボ達成',
  mission_golden_2: 'ダブルゴールド',
  mission_golden_2_desc: 'ゴールデンイベント2回タッチ',
  mission_tap_3000: 'タップウォリアー',
  mission_tap_3000_desc: '3,000回タップ',
  mission_buy_30: '大隊',
  mission_buy_30_desc: '生産者30人購入',
  mission_combo_75: 'コンボエリート',
  mission_combo_75_desc: '75コンボ達成',
  mission_golden_4: 'ゴールドハンター',
  mission_golden_4_desc: 'ゴールデンイベント4回タッチ',
  mission_earn_10m: '大富豪',
  mission_earn_10m_desc: '10M 🛸獲得',

  // Conquest
  cq_title: '世界征服',
  cq_progress: '征服状況',
  cq_infiltration_power: '浸透力',
  cq_active_conquest: '浸透中',
  cq_infiltration_progress: '浸透進行度',
  cq_time_remaining: '予想完了時間',
  cq_start_infiltration: '浸透開始',
  cq_stop_infiltration: '浸透中止',
  cq_no_power_hint: 'エージェントを雇うと浸透力が生まれます',
  cq_locked: 'ロック',
  cq_available: '侵入可能',
  cq_conquered: '征服完了',
  cq_popup_title: '征服完了！',
  cq_popup_desc: 'を征服しました！施設を建設してさらに強くなりましょう。',
  cq_back: '戻る',
  cq_invest_title: '🛸を投資して征服',
  cq_current_ip: '所持🛸',
  cq_facilities: '施設',
  cq_build: '建設',
  cq_upgrade: '強化',
  cq_next_level: '次',
  cq_counter_intel_title: '防諜警報！',
  cq_counter_intel_text: '{country}で侵入が発覚しました！進行度が減少します。',
  cq_defend_ad: '広告を見て防御',
  cq_accept_loss: '損失を受け入れる',
  cq_ending_title: '地球征服完了！',
  cq_ending_text: 'レプティリアンの陰謀は完成しました。全ての国家が影の帝国に跪きます。',
  cq_ending_time: 'プレイ時間',
  cq_ending_prestiges: '転生回数',
  cq_ending_total_ip: '総🛸',
  cq_ending_taps: '総タップ数',
  cq_ending_continue: 'プレイを続ける',
  cq_egypt: 'エジプト', cq_egypt_desc: 'ピラミッド古代基地',
  cq_brazil: 'ブラジル', cq_brazil_desc: 'アマゾン密林の隠れ家',
  cq_india: 'インド', cq_india_desc: 'ナーガ信仰潜入',
  cq_australia: 'オーストラリア', cq_australia_desc: '砂漠地下バンカー',
  cq_japan: '日本', cq_japan_desc: '技術窃取作戦',
  cq_korea: '韓国', cq_korea_desc: 'NISサイバー防御突破',
  cq_uk: 'イギリス', cq_uk_desc: 'MI5/MI6王室潜入',
  cq_russia: 'ロシア', cq_russia_desc: 'FSBシベリア作戦',
  cq_china: '中国', cq_china_desc: '世界最強の監視網',
  cq_usa: 'アメリカ', cq_usa_desc: 'CIA/NSA最終ボス',
  fac_pyramid_vault: 'ピラミッド金庫', fac_pyramid_vault_d: 'レベル毎 毎秒🛸 +5%',
  fac_nile_network: 'ナイルネットワーク', fac_nile_network_d: 'レベル毎オフライン +5%',
  fac_ancient_lab: '古代研究所', fac_ancient_lab_d: 'レベル毎TAP +10%',
  fac_amazon_hideout: 'アマゾン隠れ家', fac_amazon_hideout_d: 'レベル毎生産者割引 +2%',
  fac_samba_broadcast: 'サンバ放送局', fac_samba_broadcast_d: 'レベル毎 毎秒🛸 +8%',
  fac_jungle_lab: 'ジャングル研究所', fac_jungle_lab_d: 'レベル毎ゴールデン +5%',
  fac_naga_temple: 'ナーガ寺院', fac_naga_temple_d: 'レベル毎💎 +5%',
  fac_bollywood_studio: 'ボリウッドスタジオ', fac_bollywood_studio_d: 'レベル毎オフライン +8%',
  fac_caste_network: 'カーストネットワーク', fac_caste_network_d: 'レベル毎 毎秒🛸 +12%',
  fac_desert_bunker: '砂漠バンカー', fac_desert_bunker_d: 'レベル毎TAP +15%',
  fac_ayers_signal: 'エアーズシグナル', fac_ayers_signal_d: 'レベル毎ゴールデン +8%',
  fac_outback_base: 'アウトバック基地', fac_outback_base_d: 'レベル毎 毎秒🛸 +15%',
  fac_akiba_ai: '秋葉原AI', fac_akiba_ai_d: 'レベル毎 毎秒🛸 +20%',
  fac_ninja_intel: '忍者情報部', fac_ninja_intel_d: 'レベル毎生産者割引 +3%',
  fac_tokyo_tower: '東京タワー', fac_tokyo_tower_d: 'レベル毎💎 +8%',
  fac_gangnam_hq: '江南本部', fac_gangnam_hq_d: 'レベル毎 毎秒🛸 +25%',
  fac_cyber_command: 'サイバー司令部', fac_cyber_command_d: 'レベル毎TAP +25%',
  fac_kpop_brainwash: 'K-Pop洗脳機', fac_kpop_brainwash_d: 'レベル毎💎 +10%',
  fac_royal_infiltrate: '王室潜入', fac_royal_infiltrate_d: 'レベル毎 毎秒🛸 +30%',
  fac_london_tower: 'ロンドンタワー', fac_london_tower_d: 'レベル毎オフライン +15%',
  fac_mi6_double: 'MI6二重スパイ', fac_mi6_double_d: 'レベル毎ゴールデン +12%',
  fac_siberia_base: 'シベリア基地', fac_siberia_base_d: 'レベル毎 毎秒🛸 +40%',
  fac_kgb_remnant: 'KGB残党', fac_kgb_remnant_d: 'レベル毎生産者割引 +5%',
  fac_nuke_bunker: '核バンカー', fac_nuke_bunker_d: 'レベル毎TAP +40%',
  fac_great_wall: '万里のファイアウォール', fac_great_wall_d: 'レベル毎 毎秒🛸 +50%',
  fac_shenzhen_factory: '深圳工場', fac_shenzhen_factory_d: 'レベル毎生産者割引 +8%',
  fac_panda_spy: 'パンダスパイリング', fac_panda_spy_d: 'レベル毎ゴールデン +20%',
  fac_area51: 'エリア51', fac_area51_d: 'レベル毎 毎秒🛸 +80%',
  fac_pentagon: 'ペンタゴン', fac_pentagon_d: 'レベル毎TAP +80%',
  fac_wall_street: 'ウォール街', fac_wall_street_d: 'レベル毎💎 +25%',

  buy: '\u8CFC\u5165', max: '\u6700\u5927', level: 'Lv.', locked: '\u30ED\u30C3\u30AF', unlocked: '\u89E3\u653E',
  upgrade_locked_prev: '\u524D\u306E\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3092\u5148\u306B\u7FD2\u5F97\u3057\u3066\u304F\u3060\u3055\u3044',
  condition: '\u6761\u4EF6', cost: '\u30B3\u30B9\u30C8', owned: '\u4FDD\u6709', effect: '\u52B9\u679C', reward: '\u5831\u916C',
  close: '\u9589\u3058\u308B', confirm: '\u78BA\u8A8D', cancel: '\u30AD\u30E3\u30F3\u30BB\u30EB',

  // Conquest achievements
  ach_filter_conquest: '征服',
  ach_q01: '初征服', ach_q01_reward: '毎秒🛸 +10%',
  ach_q02: '三国征服', ach_q02_reward: 'TAP +10%',
  ach_q03: '世界の半分', ach_q03_reward: '💎獲得 +15%',
  ach_q04: '七つの旗', ach_q04_reward: 'オフライン効率 +20%',
  ach_q05: '世界征服者', ach_q05_reward: '全体 毎秒🛸 x3',
  ach_q06: '施設マスター', ach_q06_reward: '全体 毎秒🛸 x2',
  milestone_next: '次',
  settings_conquest: '征服状況',

  // Currency info
  currency_ip_name: '潜入ポイント (IP)',
  currency_ip_earn: 'タップ、エージェント自動生産、オフライン収入、広告報酬で獲得',
  currency_ip_use: 'エージェント雇用、アップグレード購入、国家征服に投資',
  currency_gc_name: '銀河クレジット (GC)',
  currency_gc_earn: 'プレステージ（組織再編）時に累計IPに基づいて獲得',
  currency_gc_use: 'プレステージアップグレード購入（生産倍率、オフライン効率など）',
  currency_cores_name: '銀河コア',
  currency_cores_earn: '2次プレステージ（銀河再編）時に累計GCに基づいて獲得',
  currency_cores_use: '2次プレステージアップグレード購入（永久バフ、自動化など）',
  currency_docs_name: '機密文書',
  currency_docs_earn: 'デイリーミッション完了、広告視聴、実績解除で獲得',
  currency_docs_use: 'ミッションタブの機密文書ショップで強力なブーストアイテムを購入',
  currency_how_earn: '獲得方法',
  currency_how_use: '使い道',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: '浸透熟練',
  pup_infiltration_mastery_desc: 'レベルごとに全体浸透力 +50%(最大 +500%)',
  pup_agent_network: 'エージェント網',
  pup_agent_network_desc: 'レベルごとにエージェント100体につき浸透力 +5%',
  pup_quick_infiltration: '連鎖浸透',
  pup_quick_infiltration_desc: '国制覇時、次の国の進捗 +10%/Lv',
  pup_critical_chance: 'クリティカル訓練',
  pup_critical_chance_desc: 'タップクリティカル率 +3%/Lv(基本10%、最大50%)',
  pup_critical_damage: 'クリティカル強化',
  pup_critical_damage_desc: 'クリティカルダメージ +1x/Lv(基本 x3)',

  // Special upgrades - conquest
  special_spy_master: 'スパイマスター',
  special_spy_master_desc: '全体浸透力 x2',

  ad_income_x5: '30分間の収入獲得',
  ad_income_x5_desc: '広告を視聴すると\n{amount} 🛸を即時獲得（30分間の収入）！',
  ad_tap_x10: 'タップ x10 (10秒)',
  ad_tap_x10_desc: '広告を視聴すると\n10秒間タップ収入が10倍に！',
  ad_free_docs_desc: '広告を視聴すると\n機密文書 📜 1枚を無料で獲得！',
  ad_prestige_desc: '広告を視聴すると\n15秒間収入が10倍に！',
  cq_tutorial_title: '🌍 世界征服ガイド',
  cq_tutorial_text: '国を征服すると<b>施設</b>を建設できます！\n施設を強化すると収入、タップ、オフライン収入など\n<b>永続的なボーナス</b>を獲得できます。\n\nエージェントを雇用すると浸透力が上がります。',
  rank_promote: '昇格',
  rank_promoted: '昇格完了！',

  // Boss events
  boss_resistance_captain: 'レジスタンス隊長',
  boss_resistance_captain_desc: '人間民兵のリーダー、歴戦の戦士',
  boss_cia_agent: 'CIA工作員',
  boss_cia_agent_desc: '機密情報を持つ秘密工作員',
  boss_mib_investigator: 'MIB捜査官',
  boss_mib_investigator_desc: 'Men In Black現場エージェント',
  boss_un_inspector: 'UN査察官',
  boss_un_inspector_desc: '国際陰謀の追跡者',
  boss_whistleblower: '内部告発者',
  boss_whistleblower_desc: '証拠を持つ裏切り者',
  boss_journalist: '調査報道記者',
  boss_journalist_desc: 'カメラを持つ執念の真実追求者',
  boss_truth_seeker: '真実の探求者',
  boss_truth_seeker_desc: '超常現象研究者',
  boss_galactic_guardian: '銀河の守護者',
  boss_galactic_guardian_desc: '宇宙法の執行者',

  boss_alert: '脅威検知！',
  boss_alert_desc: '敵が出現！タップして攻撃せよ！',
  boss_hp: 'HP',
  boss_tap_attack: 'タップで攻撃！',
  boss_double_damage: '2xダメージ (30秒)',
  boss_eliminated: '撃破完了！',
  boss_eliminated_desc: '{name}を無力化した！',
  boss_reward_ip: '+{amount} IP',
  boss_reward_docs: '+{amount} Docs',
  boss_reward_gc: '+{amount} GC',
  boss_reward_boost: 'CPS x3 ({seconds}秒)',
  boss_claim: '報酬を受け取る',
  boss_claim_double: '2倍報酬',
  boss_escaped: '逃走！',
  boss_escaped_desc: 'ターゲットが逃げた...',
  boss_revive: '再挑戦 (+20秒)',
  boss_phase2: '激昂！',
  boss_streak: '連続撃破: {n}',
  boss_time_remaining: '残り時間',
  boss_double_damage_active: '2xダメージ発動中！',

  // Agent collection
  tab_agent: 'エージェント',
  agent_collection_title: 'エージェントコレクション',
  agent_equipped: '装備中',
  agent_empty_slot: '空きスロット',
  agent_obtained: 'エージェント獲得！',
  agent_equip: '装備',
  agent_unequip: '外す',
  agent_locked: '???',
  agent_count: 'x{n}',
  agent_tutorial_title: 'エージェントコレクションガイド',
  agent_tutorial_text: '<b>ボス</b>を倒してエージェントカードを集めよう！<br><br>各エージェントには固有のパッシブボーナスがあります。<br>カードをタップしてエージェントを装備しましょう。<br><br>高レアリティ＝より強力な効果。<br>転生で装備スロットが増加します。',

  // Agent effect descriptions
  agent_effect_cps_pct: 'CPS {n}',
  agent_effect_tap_pct: 'TAP {n}',
  agent_effect_conquest_speed: '征服速度 {n}',
  agent_effect_boss_damage: 'ボスダメージ {n}',
  agent_effect_golden_chance: 'ゴールデンイベント {n}',
  agent_effect_offline_pct: 'オフライン収入 {n}',
  agent_effect_docs_rate: '文書レート {n}',
  agent_effect_gc_pct: 'GC獲得 {n}',
  agent_effect_boss_spawn_reduce: 'ボス出現 -{n}',
  agent_effect_prestige_gc_bonus: 'プレステージGC {n}',
  agent_effect_faction_favor: '勢力好感度 {n}',

  // Agent names & descriptions (25 agents)
  // Common (10)
  agent_field_spy: 'フィールドスパイ',
  agent_field_spy_desc: '現場情報でIP生産+8%アップ',
  agent_code_cracker: 'コードクラッカー',
  agent_code_cracker_desc: '暗号解読でタップ力+10%アップ',
  agent_shadow_runner: 'シャドウランナー',
  agent_shadow_runner_desc: '隠密技術で征服速度+10%アップ',
  agent_data_miner: 'データマイナー',
  agent_data_miner_desc: 'データ収集でオフライン収入+15%アップ',
  agent_lookout: '見張り番',
  agent_lookout_desc: '鋭い目でゴールデンイベント確率+10%アップ',
  agent_doc_thief: '文書泥棒',
  agent_doc_thief_desc: '文書窃盗で文書獲得+15%アップ',
  agent_network_bot: 'ネットワークボット',
  agent_network_bot_desc: '自動ネットワークでCPS+10%アップ',
  agent_safe_cracker: '金庫破り',
  agent_safe_cracker_desc: '金庫技術でタップ力+12%アップ',
  agent_recruit: 'リクルート',
  agent_recruit_desc: '新米戦士でボスダメージ+10%アップ',
  agent_comm_officer: '通信士官',
  agent_comm_officer_desc: '通信技術で勢力好感度+10%アップ',

  // Rare (8)
  agent_infiltration_ace: '潜入エース',
  agent_infiltration_ace_desc: 'エリート潜入でCPS+20%アップ',
  agent_mind_bender: 'マインドベンダー',
  agent_mind_bender_desc: '超能力で征服速度+25%アップ',
  agent_vault_raider: 'ヴォールトレイダー',
  agent_vault_raider_desc: '金庫専門でGC獲得+20%アップ',
  agent_signal_jammer: 'シグナルジャマー',
  agent_signal_jammer_desc: '妨害でボス出現間隔-15%短縮',
  agent_double_agent: '二重スパイ',
  agent_double_agent_desc: '二重忠誠でオフライン収入+30%アップ',
  agent_hive_mind: 'ハイヴマインド',
  agent_hive_mind_desc: '集合意識で文書レート+25%アップ',
  agent_boss_hunter: 'ボスハンター',
  agent_boss_hunter_desc: '専門追跡でボスダメージ+25%アップ',
  agent_faction_liaison: '勢力連絡官',
  agent_faction_liaison_desc: '外交関係で勢力好感度+25%アップ',

  // Epic (5)
  agent_reptilian_elite: 'レプティリアンエリート',
  agent_reptilian_elite_desc: 'エリート戦士でCPS+35%アップ',
  agent_galaxy_commander: 'ギャラクシーコマンダー',
  agent_galaxy_commander_desc: '銀河の権威でGC獲得+40%アップ',
  agent_dark_secretary: 'ダークセクレタリー',
  agent_dark_secretary_desc: '影の官僚でプレステージGC+20%アップ',
  agent_omega_operative: 'オメガオペレーティブ',
  agent_omega_operative_desc: '究極の戦士でボスダメージ+50%アップ',
  agent_shapeshifter: 'シェイプシフター',
  agent_shapeshifter_desc: '変身の達人でタップ力+40%アップ',

  // Legendary (2)
  agent_the_overlord: 'ジ・オーバーロード',
  agent_the_overlord_desc: '最高司令官で全CPS+50%アップ',
  agent_grand_architect: 'グランドアーキテクト',
  agent_grand_architect_desc: '宇宙の設計者で征服速度+60%アップ',
  // Faction system
  faction_status_title: '勢力状況',
  faction_favorability: '好感度',
  faction_tier: 'ティア {n}',

  // Faction event popup
  faction_event_help: '助ける',
  faction_event_ignore: '無視',
  faction_event_timer: '残り{seconds}秒',
  faction_event_reward: '+{favor} {faction} 好感度, -{loss} {target} 好感度',
  faction_event_ip_reward: '+{amount} IP報酬',
  faction_event_ad_bonus: '広告視聴: +{n} {faction} 好感度',

  // Faction names
  faction_illuminati: 'イルミナティ',
  faction_illuminati_desc: '闇から世界を操る秘密の人間支配者',
  faction_grey: 'グレイエイリアン',
  faction_grey_desc: '技術を共有する地球外生命体',
  faction_mib: 'MIBレジスタンス',
  faction_mib_desc: 'エイリアンの影響に対抗する秘密人間組織',

  // Faction bonus descriptions
  faction_illuminati_bonus1: 'CPS +10%',
  faction_illuminati_bonus2: 'CPS +15%',
  faction_illuminati_bonus3: '征服速度 +20%',
  faction_grey_bonus1: 'タップ +15%',
  faction_grey_bonus2: 'タップ +20%',
  faction_grey_bonus3: 'ゴールデンクッキー +25%',
  faction_mib_bonus1: 'ボスダメージ +20%',
  faction_mib_bonus2: 'オフライン収入 +15%',
  faction_mib_bonus3: 'ボス出現 -15%',

  // Event titles and descriptions
  event_illu_decode_title: '機密傍受',
  event_illu_decode_desc: 'イルミナティが政府の機密ファイルを傍受しています。解読を手伝いますか？',
  event_illu_stock_title: '市場操作',
  event_illu_stock_desc: 'イルミナティがグローバル株式市場を操作しようとしています。インサイダー情報を提供しますか？',
  event_illu_surveillance_title: '監視ネットワーク',
  event_illu_surveillance_desc: 'イルミナティが秘密の監視ネットワークを構築中です。建設を支援しますか？',
  event_illu_meeting_title: '秘密サミット',
  event_illu_meeting_desc: '世界の指導者が集まる場でイルミナティの秘密会議が開催されます。警備を担当しますか？',
  event_illu_bribe_title: 'エイリアン外交',
  event_illu_bribe_desc: 'イルミナティがエイリアン外交官に賄賂を渡そうとしています。荷物を届けますか？',

  event_grey_experiment_title: '人体研究',
  event_grey_experiment_desc: 'グレイエイリアンが人間に対して実験を行っています。研究所を警備しますか？',
  event_grey_mindcontrol_title: 'マインドコントロール装置',
  event_grey_mindcontrol_desc: 'グレイエイリアンが都市にマインドコントロール装置を設置しようとしています。建設を手伝いますか？',
  event_grey_crash_title: '墜落回収',
  event_grey_crash_desc: 'グレイの偵察船が砂漠に墜落しました。乗組員の救出を手伝いますか？',
  event_grey_terraform_title: '秘密テラフォーミング',
  event_grey_terraform_desc: 'グレイエイリアンが密かに島をテラフォーミングしています。資源を提供しますか？',
  event_grey_hack_title: '衛星ハッキング',
  event_grey_hack_desc: 'グレイエイリアンが地球の衛星ネットワークをハッキングしようとしています。アクセスコードを提供しますか？',

  event_mib_raid_title: 'エイリアン前哨基地襲撃',
  event_mib_raid_desc: 'MIBがエイリアン前哨基地への襲撃を計画しています。攻撃に参加しますか？',
  event_mib_safehouse_title: 'セーフハウス発見',
  event_mib_safehouse_desc: 'MIBが隠されたイルミナティのセーフハウスを発見しました。襲撃を手伝いますか？',
  event_mib_weapons_title: '兵器開発',
  event_mib_weapons_desc: 'MIBが対エイリアン兵器を開発しています。希少素材を提供しますか？',
  event_mib_evacuate_title: '民間人避難',
  event_mib_evacuate_desc: 'MIBがエイリアン攻撃地帯から民間人を避難させる必要があります。手伝いますか？',
  event_mib_expose_title: '汚職暴露',
  event_mib_expose_desc: 'MIBがイルミナティの汚職を公に暴露しようとしています。文書を流出させますか？',

  // Shadow Contact (mid-game ad choices)
  sc_title: '闇の接触',
  sc_accept: '取引する',
  sc_decline: '断る',
  sc_offer_intel: '諜報レポート',
  sc_offer_intel_desc: '潜入工作員が{amount} 🛸相当の機密情報を提供します',
  sc_offer_serum: '実験用セラム',
  sc_offer_serum_desc: 'タップ力を30秒間10倍に増幅するエイリアン研究サンプル',
  sc_offer_tech: '闇市テクノロジー',
  sc_offer_tech_desc: '30秒間収入を10倍にする盗まれたエイリアン技術',
  sc_offer_docs: '機密文書の隠し場所',
  sc_offer_docs_desc: '機密文書3枚が隠された秘密の保管庫 📜',
  boss_warning: '警告',
  boss_warning_sub: '強力な敵が近づいている...',
  boss_tutorial_title: 'ボス戦！',
  boss_tutorial_text: 'ボスが出現！時間内にタップしてダメージを与えよう。<br><br>ボスを倒すと<b>IP、ドキュメント、エージェントカード</b>を獲得！<br>広告視聴で<b>2倍ダメージ</b>ブースト。',
  // === Infiltration Run (generated) ===
  tab_infiltration: "Infiltrate",
  infil_eyebrow: "INFILTRATION OPS",
  infil_title: "Infiltration Run",
  infil_subtitle: "Slip in, climb the ranks, get out clean.",
  infil_tutorial_note: "First run: learn the ropes. Chasing the top rank too hard gets you caught.",
  infil_agent_stats: "Agent Stats",
  infil_highest_career: "Best Career",
  infil_total_runs: "Total Runs",
  infil_total_success: "Successes",
  infil_tradeoff_hint: "Safe = small reward, low rank. Greedy = high detection, high risk. Weigh every choice.",
  infil_start: "Start Infiltration",
  infil_start_tutorial: "Start Tutorial Run",
  infil_cooldown: "Cooldown",
  infil_cancel: "Cancel",
  infil_detection: "Detection",
  infil_step: "Event",
  infil_difficulty: "Diff",
  infil_selecting: "Selecting",
  infil_choice_success: "SUCCESS",
  infil_choice_fail: "FAILED",
  infil_roll: "Roll",
  infil_next: "Next",
  infil_to_extraction: "To Extraction",
  infil_extraction_cat: "FINAL STEP",
  infil_extraction_title: "Extraction",
  infil_extraction_desc: "All events cleared. Slip out now — the lower your detection, the safer.",
  infil_attempt_extraction: "Attempt Extraction",
  infil_final_chance: "Extraction Chance",
  infil_result_success: "INFILTRATION SUCCESS",
  infil_result_fail: "CAUGHT",
  infil_result_success_sub: "You slipped out and secured a cover career.",
  infil_result_fail_sub: "Security caught you. Nothing gained this time.",
  infil_docs: "Docs",
  infil_cleared: "Cleared",
  infil_career_earned: "Career Secured",
  infil_fail_note: "No reward. A short cooldown before the next run.",
  infil_retry_ad: "Watch Ad: Second Chance",
  infil_retry_title: "Second Chance",
  infil_retry_desc: "Watch a short ad to lower your detection and retry the extraction once.",
  infil_retry_confirm: "Watch Ad",
  infil_close: "Close",
  infil_stat_disguise: "Disguise",
  infil_stat_combat: "Combat",
  infil_stat_hacking: "Hacking",
  infil_stat_charisma: "Charisma",
  infil_stat_none: "No Check",
  infil_tag_safe: "SAFE",
  infil_tag_risky: "RISKY",
  infil_tag_aggressive: "ALL-IN",
  infil_career_cleaner: "Cleaner",
  infil_career_guard: "Guard",
  infil_career_clerk: "Clerk",
  infil_career_manager: "Manager",
  infil_career_executive: "Executive",
  infil_career_director: "Director",
  infil_career_warrior: "Warrior",
  infil_career_none: "None",
  infil_ev_patrol_cat: "Infiltration Case / Corporate State",
  infil_ev_patrol_title: "Patrol Approaching",
  infil_ev_patrol_desc: "A security patrol is heading straight for you. How do you react?",
  infil_ch_patrol_a_label: "Wait in the shadows",
  infil_ch_patrol_a_desc: "Hold your breath until they pass. Safe, but you lose time.",
  infil_ch_patrol_b_label: "Greet them as staff",
  infil_ch_patrol_b_desc: "Nod politely in your cover identity and walk past.",
  infil_ch_patrol_c_label: "Take them down",
  infil_ch_patrol_c_desc: "Ambush the patrol and force through. Big reward, big risk.",
  infil_ev_security_check_cat: "Infiltration Case / Corporate State",
  infil_ev_security_check_title: "Security Checkpoint",
  infil_ev_security_check_desc: "A manned checkpoint blocks the corridor ahead.",
  infil_ch_security_check_a_label: "Find a side route",
  infil_ch_security_check_a_desc: "Quietly slip down an adjacent passage.",
  infil_ch_security_check_b_label: "Show forged pass",
  infil_ch_security_check_b_desc: "Present a well-made forged access pass.",
  infil_ch_security_check_c_label: "Hack the scanner",
  infil_ch_security_check_c_desc: "Breach the scanner terminal and kill the alarm.",
  infil_ev_informant_cat: "Infiltration Case / Corporate State",
  infil_ev_informant_title: "Recruit an Informant",
  infil_ev_informant_desc: "An insider might hand over classified files — for a price.",
  infil_ch_informant_a_label: "Take the anonymous tip",
  infil_ch_informant_a_desc: "Check the drop box without making contact.",
  infil_ch_informant_b_label: "Persuade the insider",
  infil_ch_informant_b_desc: "Win over the staffer with smooth talk.",
  infil_ch_informant_c_label: "Strong-arm the files",
  infil_ch_informant_c_desc: "Threaten them into surrendering the data.",
  infil_ev_cctv_cat: "Infiltration Case / Corporate State",
  infil_ev_cctv_title: "Bypass the CCTV",
  infil_ev_cctv_desc: "A ceiling of cameras sweeps the whole hall.",
  infil_ch_cctv_a_label: "Move through blind spots",
  infil_ch_cctv_a_desc: "Creep slowly along the camera blind spots.",
  infil_ch_cctv_b_label: "Loop the feed",
  infil_ch_cctv_b_desc: "Splice a fake loop into the surveillance feed.",
  infil_ch_cctv_c_label: "Smash the cameras",
  infil_ch_cctv_c_desc: "Wreck the cameras and rush past.",
  infil_ev_fake_id_cat: "Infiltration Case / Corporate State",
  infil_ev_fake_id_title: "ID Inspection",
  infil_ev_fake_id_desc: "Guards are checking every ID in a long queue.",
  infil_ch_fake_id_a_label: "Leave the queue",
  infil_ch_fake_id_a_desc: "Quietly drop out and find another way.",
  infil_ch_fake_id_b_label: "Present forged ID",
  infil_ch_fake_id_b_desc: "Pass the checkpoint with a crafted forgery.",
  infil_ch_fake_id_c_label: "Sweet-talk the guard",
  infil_ch_fake_id_c_desc: "Talk your way past with slick charm.",
  infil_ev_parking_cat: "Infiltration Case / Corporate State",
  infil_ev_parking_title: "Underground Parking",
  infil_ev_parking_desc: "The garage is your way in, but a guard patrols it.",
  infil_ch_parking_a_label: "Hide behind vehicles",
  infil_ch_parking_a_desc: "Tuck yourself between parked cars.",
  infil_ch_parking_b_label: "Neutralize the guard",
  infil_ch_parking_b_desc: "Silently subdue the garage guard.",
  infil_ch_parking_c_label: "Pose as valet",
  infil_ch_parking_c_desc: "Steal a valet uniform and stroll in.",
  infil_ev_server_room_cat: "Infiltration Case / Corporate State",
  infil_ev_server_room_title: "Server Room Breach",
  infil_ev_server_room_desc: "The core data sits behind a hardened server-room door.",
  infil_ch_server_room_a_label: "Crawl the vents",
  infil_ch_server_room_a_desc: "Take the narrow vents. Slow but safe.",
  infil_ch_server_room_b_label: "Seize admin access",
  infil_ch_server_room_b_desc: "Hijack admin rights to open the room.",
  infil_ch_server_room_c_label: "Force the door",
  infil_ch_server_room_c_desc: "Rip open the security door and barge in.",
  infil_ev_board_meeting_cat: "Infiltration Case / Corporate State",
  infil_ev_board_meeting_title: "Board Meeting Infiltration",
  infil_ev_board_meeting_desc: "Top executives are trading secrets behind closed doors.",
  infil_ch_board_meeting_a_label: "Eavesdrop from the hall",
  infil_ch_board_meeting_a_desc: "Listen quietly from outside the room.",
  infil_ch_board_meeting_b_label: "Pose as consultant",
  infil_ch_board_meeting_b_desc: "Blend in as an outside consultant.",
  infil_ch_board_meeting_c_label: "Storm the room",
  infil_ch_board_meeting_c_desc: "Raid the room and seize every secret. Warrior play.",
  infil_ev_reporter_cat: "Infiltration Case / Corporate State",
  infil_ev_reporter_title: "Shake the Reporter",
  infil_ev_reporter_desc: "A dogged journalist is tailing your every move.",
  infil_ch_reporter_a_label: "Blend into the crowd",
  infil_ch_reporter_a_desc: "Melt into a busy street to lose the tail.",
  infil_ch_reporter_b_label: "Change disguise",
  infil_ch_reporter_b_desc: "Swap outerwear and reverse direction.",
  infil_ch_reporter_c_label: "Feed false leads",
  infil_ch_reporter_c_desc: "Approach first and plant fake information.",
  infil_ev_party_cat: "Infiltration Case / Corporate State",
  infil_ev_party_title: "Crash the Party",
  infil_ev_party_desc: "A gala hides the people you need to reach.",
  infil_ch_party_a_label: "Carry a waiter tray",
  infil_ch_party_a_desc: "Grab an empty tray and pose as service.",
  infil_ch_party_b_label: "Pose as a guest",
  infil_ch_party_b_desc: "Mingle smoothly as an invited guest.",
  infil_ch_party_c_label: "Enter as a VIP",
  infil_ch_party_c_desc: "Dress as a VIP and stride through the front.",
  infil_ev_drone_cat: "Infiltration Case / Corporate State",
  infil_ev_drone_title: "Drone Surveillance",
  infil_ev_drone_desc: "A surveillance drone sweeps the open yard.",
  infil_ch_drone_a_label: "Wait under cover",
  infil_ch_drone_a_desc: "Hide beneath a structure until it passes.",
  infil_ch_drone_b_label: "Jam the signal",
  infil_ch_drone_b_desc: "Jam its comms and blind the drone.",
  infil_ch_drone_c_label: "Shoot it down",
  infil_ch_drone_c_desc: "Down the drone. Sure, but it leaves traces.",
  infil_ev_guard_shift_cat: "Infiltration Case / Corporate State",
  infil_ev_guard_shift_title: "Guard Shift Change",
  infil_ev_guard_shift_desc: "A shift change opens a brief window in the watch.",
  infil_ch_guard_shift_a_label: "Wait for the swap",
  infil_ch_guard_shift_a_desc: "Wait for the gap and move on the change.",
  infil_ch_guard_shift_b_label: "Pose as relief guard",
  infil_ch_guard_shift_b_desc: "Walk into the post as the relief guard.",
  infil_ch_guard_shift_c_label: "Ambush the guard",
  infil_ch_guard_shift_c_desc: "Jump the guard just before the swap.",
  infil_ev_vault_cat: "Infiltration Case / Corporate State",
  infil_ev_vault_title: "The Secret Vault",
  infil_ev_vault_desc: "A hidden vault holds the crown-jewel documents.",
  infil_ch_vault_a_label: "Skip the vault",
  infil_ch_vault_a_desc: "Leave the vault and grab only your target.",
  infil_ch_vault_b_label: "Crack the e-lock",
  infil_ch_vault_b_desc: "Hack the electronic lock and open it.",
  infil_ch_vault_c_label: "Blow the vault",
  infil_ch_vault_c_desc: "Blast it open and grab everything. Top reward.",
  infil_ev_vaccine_cat: "Infiltration Case / Corporate State",
  infil_ev_vaccine_title: "Vaccination Cover",
  infil_ev_vaccine_desc: "A pop-up clinic is the perfect cover to get inside.",
  infil_ch_vaccine_a_label: "Join the queue",
  infil_ch_vaccine_a_desc: "Line up as an ordinary patient.",
  infil_ch_vaccine_b_label: "Wear a medic gown",
  infil_ch_vaccine_b_desc: "Put on a medic gown and walk inside.",
  infil_ch_vaccine_c_label: "Impersonate the chief",
  infil_ch_vaccine_c_desc: "Pose as the director and dismiss the staff.",
  infil_ev_broadcast_cat: "Infiltration Case / Corporate State",
  infil_ev_broadcast_title: "Broadcast Control Room",
  infil_ev_broadcast_desc: "The station feed could carry your message — or your evidence.",
  infil_ch_broadcast_a_label: "Read the logs",
  infil_ch_broadcast_a_desc: "Quietly review the broadcast logs only.",
  infil_ch_broadcast_b_label: "Intercept the feed",
  infil_ch_broadcast_b_desc: "Hack the feed and siphon the data.",
  infil_ch_broadcast_c_label: "Pose as live director",
  infil_ch_broadcast_c_desc: "Impersonate the live director and take the room.",
  infil_ev_border_cat: "Infiltration Case / Corporate State",
  infil_ev_border_title: "Border Checkpoint",
  infil_ev_border_desc: "A guarded border stands between you and the target.",
  infil_ch_border_a_label: "Take an unwatched trail",
  infil_ch_border_a_desc: "Cross via an unmonitored back trail.",
  infil_ch_border_b_label: "Persuade the officer",
  infil_ch_border_b_desc: "Talk the inspector out of suspicion.",
  infil_ch_border_c_label: "Pose as a diplomat",
  infil_ch_border_c_desc: "Cross under a diplomatic cover identity.",
  infil_ch_border_d_label: "Ram the barrier",
  infil_ch_border_d_desc: "Smash the barrier with a vehicle and floor it.",
} as const;
